import FacebookNew from 'assets/svg/facebook/facebook-black.svg'
import Facebook from 'assets/svg/facebook/social-facebook.svg'
import InstagramNew from 'assets/svg/instagram/instagram-black.svg'
import Instagram from 'assets/svg/instagram/social-instagram.svg'
import LinkedinNew from 'assets/svg/linkedin/linkedin-black.svg'
import Linkedin from 'assets/svg/linkedin/social-linkedin.svg'
import Twitter from 'assets/svg/twitter/social-twitter.svg'
import TwitterNew from 'assets/svg/twitter/x-black.svg'
import Youtube from 'assets/svg/youtube/social-youtube.svg'
import YoutubeNew from 'assets/svg/youtube/youtube-black.svg'
import Image from 'common/components/Image'
import { TSocialMediaName } from 'common/components/SocialMedia/interface'
import cdn from 'lib/cdn'
import GA4 from 'lib/google-analytics-4'
import { useCallback, useMemo } from 'react'

interface ISocialMedia {
  name: TSocialMediaName
  src: string
  component: JSX.Element
}

const SOCIAL_MEDIAS: Array<ISocialMedia> = [
  {
    name: 'Facebook',
    src: 'https://www.facebook.com/ralalicom',
    component: <Facebook />,
  },
  {
    name: 'LinkedIn',
    src: 'https://www.linkedin.com/company/ralali-com',
    component: <Linkedin />,
  },
  {
    name: 'Youtube',
    src: 'https://www.youtube.com/channel/UCA7tGuG-avOIEzcL97ybZqQ',
    component: <Youtube />,
  },
  {
    name: 'Twitter',
    src: 'https://x.com/ralalicom',
    component: <Twitter />,
  },
  {
    name: 'Instagram',
    src: 'https://www.instagram.com/ralalicom',
    component: <Instagram />,
  },
  {
    name: 'FacebookNew',
    src: 'https://www.facebook.com/ralalicom',
    component: <FacebookNew />,
  },
  {
    name: 'LinkedInNew',
    src: 'https://www.linkedin.com/company/ralali-com',
    component: <LinkedinNew />,
  },
  {
    name: 'YoutubeNew',
    src: 'https://www.youtube.com/channel/UCA7tGuG-avOIEzcL97ybZqQ',
    component: <YoutubeNew />,
  },
  {
    name: 'TwitterNew',
    src: 'https://x.com/ralalicom',
    component: <TwitterNew />,
  },
  {
    name: 'InstagramNew',
    src: 'https://www.instagram.com/ralalicom',
    component: <InstagramNew />,
  },
  {
    name: 'Google Play',
    src: 'https://play.google.com/store/apps/details?id=com.ralali',
    component: (
      <Image
        width="106px"
        src={cdn({ path: '/assets/img/google-play-badge.png' })}
      />
    ),
  },
  {
    name: 'Google Play',
    src: 'https://play.google.com/store/apps/details?id=com.ralali',
    component: (
      <Image
        width="106px"
        src={cdn({ path: '/assets/img/footer/store/googleplay.png' })}
      />
    ),
  },
  {
    name: 'Apple Store',
    src: 'https://itunes.apple.com/us/app/ralali/id1325479051',
    component: (
      <Image
        width="106px"
        src={cdn({ path: '/assets/img/footer/store/applestore.png' })}
      />
    ),
  },
]

function SocialMedia({
  children,
  name,
}: {
  children?: JSX.Element
  name?: TSocialMediaName
}): JSX.Element {
  const { name: socmedName, src, component } = useMemo(() => {
    return SOCIAL_MEDIAS.find((item) => item.name === name)
  }, [name])

  const handleTracker = useCallback(() => {
    const { trackEvent } = GA4()

    trackEvent({
      eventName: ['Google Play', 'Apple Store'].includes(socmedName)
        ? 'app_download'
        : 'follow_us',
      eventCategory: 'Click Engagement',
      params: {
        click_detail: socmedName,
      },
    })
  }, [socmedName])

  return (
    <a
      href={src}
      target="_blank"
      rel="noreferrer"
      data-testid="social-media-link"
      onClick={handleTracker}
    >
      {children || component}
    </a>
  )
}

export default SocialMedia
